function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z",
  fill: "#FFF7E0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0234 4.5C10.3516 4.5 10.6797 4.6875 10.8438 4.99219L15.9062 14.3672C16.0469 14.6484 16.0469 15 15.8828 15.3047C15.7188 15.5859 15.4141 15.75 15.0859 15.75H4.96094C4.60938 15.75 4.30469 15.5859 4.14062 15.3047C3.97656 15 3.97656 14.6484 4.11719 14.3672L9.17969 4.99219C9.34375 4.6875 9.67188 4.5 10.0234 4.5ZM5.26562 14.625H14.7578L10.0234 5.83594L5.26562 14.625ZM10.0234 13.6875C9.60156 13.6875 9.27344 13.3594 9.27344 12.9375C9.27344 12.5156 9.60156 12.1875 10.0234 12.1875C10.4219 12.1875 10.7734 12.5156 10.7734 12.9375C10.7734 13.3594 10.4219 13.6875 10.0234 13.6875ZM10.0234 8.8125C10.4453 8.8125 10.7969 9.1875 10.75 9.63281L10.5625 11.1328C10.5391 11.4141 10.3047 11.625 10.0234 11.625C9.71875 11.625 9.48438 11.4141 9.46094 11.1328L9.29688 9.63281C9.25 9.1875 9.57812 8.8125 10.0234 8.8125Z",
  fill: "#FDB71A"
});

function SvgWarningCube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCube);
export default __webpack_public_path__ + "static/media/warning-cube.bf836984.svg";
export { ForwardRef as ReactComponent };